import BaseSearchService from "./BaseSearchService";

export default class OrderService extends BaseSearchService {

    public completePayment(orderid: number, languageId: string): Promise<any> {

        return this.axios
            .post(`/shop/completepayment?languageId=${languageId}&orderid=${orderid}`)
            .then((res) => {
                return res.data;
            });
    }
   
}